export default function convertSpotifyWebLinkToNative(webLink, nativeLinks) {
  let returnedLink;
  if (nativeLinks === false) {
    returnedLink = webLink;
  } else {
    // parse string on "/"
    const parsedLink = webLink.split("/")

    const lastItemIndex = parsedLink.length - 1
    const secondLastItemIndex = lastItemIndex - 1

    const id = parsedLink[lastItemIndex]
    const type = parsedLink[secondLastItemIndex]

    // compose native spotify url
    // https://developer.spotify.com/documentation/general/guides/content-linking-guide/
    // https://stackoverflow.com/a/48395049/16330832

    const newNativeUrlString = `spotify:${type}:${id}`

    returnedLink = newNativeUrlString;
  }

  return returnedLink;
}
